import type {FCOptChildren, FCReqChildren} from '../helpers/react-helpers';
import { withClass} from '../helpers/react-helpers'
import {FlexButtonBar} from './buttons'
import cn from 'classnames'

export const PaddedIndexTable = withClass<'table'>('table','index-table no-links')
export const LinkedIndexTable = withClass<'table'>('table','index-table')

interface ItCellProps {
    noWrap?: boolean
    center?: boolean
    ellipsis?: boolean
    width?: string|number
    maxWidth?: string|number
    /** Tooltip title */
    title?: string
    colSpan?: number
}

export const ItCell: FCOptChildren<ItCellProps> = ({center,noWrap,ellipsis,width,maxWidth,...props}) => (
    <td className={cn({tcenter:center,nowrap:noWrap,ellipsis})} style={{width,minWidth:width,maxWidth}} {...props} />
)

interface ItHeaderProps {
    width?: string|number
    maxWidth?: string|number
    /** Horizontally center the content */
    center?: boolean
    wrap?: boolean
}


// Must use width+min-width, not max-width: https://stackoverflow.com/a/68978495/65387
export const ItHeader: FCOptChildren<ItHeaderProps> = ({center,wrap,width,maxWidth,children}) => (
    <th className={cn({tcenter:center,nowrap:!wrap})} style={{width,minWidth:width,maxWidth}}>{children}</th>
)

/**
 * A table data cell containing one or more .btn's
 */
export const BtnCell: FCReqChildren = ({children}) => (
    <td className="sm-pad tcenter">
        <FlexButtonBar noWrap>{children}</FlexButtonBar>
    </td>
)

export const SimpleTable = withClass('table','simple-table')
